<ng-template #pending>
    <div class="placeholder-container" [ngClass]="{ 'placeholder-container-compressed': compressed }">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<ng-container *ngIf="inView && (relewiseResponse | async)?.data as products; else pending">
    <ng-container *ngIf="products.length">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="action-container">
                        <h2 class="headline display-4" [ngClass]="{ 'text-center': centerAlign && !slider.hasPaging }">
                            {{ headline }}
                        </h2>

                        <div class="kk-slider-buttons" *ngIf="slider.hasPaging">
                            <button
                                class="kk-slider-button slider-button"
                                [ngClass]="{ 'button-faded': !slider.pagingLeftPossible }"
                                (click)="slider.previous()"
                            >
                                <span class="arrow kk-float-horizontally-left">
                                    <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                                </span>
                                <span class="kk-visuallyhidden"> {{ 'general.action.next' | translateSafe }}</span>
                            </button>
                            <button
                                class="kk-slider-button slider-button"
                                [ngClass]="{ 'button-faded': !slider.pagingRightPossible }"
                                (click)="slider.next()"
                            >
                                <span class="arrow kk-float-horizontally-right">
                                    <app-svg-icon aria-hidden="true" iconName="chevron_right"></app-svg-icon>
                                </span>
                                <span class="kk-visuallyhidden">{{ 'general.action.previous' | translateSafe }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="slider">
                        <div class="slider-container" [ngStyle]="{ 'end-gradient': slider.hasPaging }">
                            <app-slider
                                [scrollByItems]="2"
                                [style]="{
                                    paddingRight: slider.hasPaging ? '30px' : '0',
                                    scrollPaddingRight: slider.hasPaging ? '30px' : '0'
                                }"
                                [centerAlign]="centerAlign"
                                #slider
                            >
                                <div
                                    class="slider-item"
                                    [ngClass]="{ 'slider-item-compressed': compressed }"
                                    *ngFor="let product of products; let i = index"
                                    [appImpressionTracking]="product"
                                    [index]="i + 1"
                                    [impressionSource]="type | impressionType"
                                >
                                    <div class="slider-item-inner">
                                        <app-product-card
                                            [line]="product"
                                            [impressionSource]="type | impressionType"
                                            [index]="i + 1"
                                            [compressed]="compressed"
                                        ></app-product-card>
                                    </div>
                                </div>
                            </app-slider>
                        </div>
                    </div>
                    <div class="slider-bullets d-none d-lg-block" *ngIf="slider.pages.length > 1">
                        <button
                            class="slider-bullet"
                            (click)="slider.goToPage(page)"
                            [ngClass]="{ 'active-bullet': i === slider.activePage }"
                            *ngFor="let page of slider.pages; trackBy: slider.trackByPage; let i = index"
                        >
                            <span aria-hidden="true">&bull;</span>
                            <span class="kk-visuallyhidden">
                                {{ 'general.action.goToPage' | translateSafe: { page: i + 1 } }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
